import React, { useState } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
// core components
import styles from "../../assets/jss/material-dashboard-react/components/tableStyle.js";

const useStyles = makeStyles(styles);

export default function CustomTable({
  tableHead,
  tableData,
  tableHeaderColor = "gray",
  rankTable
}) {
  const classes = useStyles();
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const handleSort = (columnIndex) => {
    const isAsc = sortedColumn === columnIndex && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortedColumn(columnIndex);
  };

  const getSortedData = () => {
    if (sortedColumn === null) {
      return tableData;
    }
    const sortedData = [...tableData];
    sortedData.sort((a, b) => {
      if (a[sortedColumn] < b[sortedColumn]) {
        return sortDirection === "asc" ? -1 : 1;
      }
      if (a[sortedColumn] > b[sortedColumn]) {
        return sortDirection === "asc" ? 1 : -1;
      }
      return 0;
    });
    return sortedData;
  };

  const sortedData = getSortedData();

  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow className={classes.tableHeadRow}>
              {tableHead.map((prop, key) => {
                return (
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                    onClick={() => handleSort(key)}
                    style={{ cursor: "pointer", textAlign: (key !== 0 && rankTable) ? "center" : "left"}}
                  >
                    {prop}
                    {sortedColumn === key
                      ? sortDirection === "asc"
                        ? " ▲"
                        : " ▼"
                      : ""}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {sortedData.map((row, rowIndex) => {
            return (
              <TableRow key={rowIndex} className={classes.tableBodyRow}>
                {row.map((cell, cellIndex) => {
                  return (
                    <TableCell className={classes.tableCell} key={cellIndex} style={{ cursor: "pointer", textAlign: (cellIndex !== 0 && rankTable) ? "center" : "left" }}>
                      {cell}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  ),
  tableData: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
        PropTypes.node,
      ])
    )
  ),
};

